import api from './api';

export interface PreplanRequestRecord {
  id: number; created_at: string; user_email: string; region_name: string; target_date: string;
  preference_filter: string | null; include_assigned_moves: boolean | number; request_text: string;
  ai_strategy: string | null; ai_priorities: string[]; ai_reason: string | null;
  ai_uncovered: string[]; ai_confidence: number | null; ai_model: string | null; ai_error: string | null;
  final_strategy: string | null; final_priorities: string[]; plan_id: string | null; generated_at: string | null;
}

export interface RequestFilters {
  search?: string; region?: string; plan_date?: string;
  outcome?: 'all' | 'generated' | 'not_generated' | 'ai_error' | 'uncovered';
  limit?: number; offset?: number;
}

export interface RequestAuditResponse {
  items: PreplanRequestRecord[]; total: number; limit: number; offset: number;
}

export async function getPreplanRequests(params: RequestFilters, signal?: AbortSignal): Promise<RequestAuditResponse> {
  const response = await api.get('/smart-dispatch/strategy-requests', { params, signal });
  return response.data;
}
